import { useCallback, useMemo } from 'react';
import {
  useLocation,
  useNavigate,
  type NavigateOptions,
} from 'react-router-dom';
import {
  isClientWebRole,
  withPortalPrefix,
} from '@core/portal/clientPortal.util';
import { useUserStore } from '@core/user/useUserStore';
import usePortalAccess from '@/access/usePortalAccess';

export const usePortalPath = () => {
  const access = usePortalAccess();
  const role = useUserStore((state) => state.currentUser?.role);

  const isClientPortal = useMemo(() => {
    if (role) {
      return isClientWebRole(role);
    }

    return access.isClientPortal;
  }, [access.isClientPortal, role]);

  const path = useCallback(
    (routePath: string) => withPortalPrefix(routePath),
    [],
  );

  return { isClientPortal, path };
};

export const usePortalNavigate = () => {
  const navigate = useNavigate();
  const { path } = usePortalPath();

  return useCallback(
    (routePath: string, options?: NavigateOptions) =>
      navigate(path(routePath), options),
    [navigate, path],
  );
};
